/**
 * NO04 - Ordre Search Reducer
 */

import NO04 from '../../models/NO04';
import * as actionTypes from '../actions/actionTypesNO04';

export interface NO04State {
  orders: NO04[];
  loading: boolean;
  loadingMore: boolean;
  error: string | null;
  currentPage: number;
  pageSize: number;
  hasMore: boolean;
  lastSearchParams: any;
  orderDetail: any | null;
  orderDetailLoading: boolean;
}

const initialState: NO04State = {
  orders: [],
  loading: false,
  loadingMore: false,
  error: null,
  currentPage: 0,
  pageSize: 100,
  hasMore: true,
  lastSearchParams: null,
  orderDetail: null,
  orderDetailLoading: false,
};

const NO04Reducer = (state = initialState, action: any): NO04State => {
  switch (action.type) {
    case actionTypes.NO04_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        currentPage: 0,
        lastSearchParams: action.payload,
      };

    case actionTypes.NO04_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        orders: action.payload.orders,
        hasMore: action.payload.hasMore,
        currentPage: 0,
        error: null,
      };

    case actionTypes.NO04_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        orders: [],
        hasMore: false,
      };

    case actionTypes.NO04_LOAD_MORE_REQUEST:
      return { ...state, loadingMore: true, error: null };

    case actionTypes.NO04_LOAD_MORE_SUCCESS:
      return {
        ...state,
        loadingMore: false,
        orders: [...state.orders, ...action.payload.orders],
        hasMore: action.payload.hasMore,
        currentPage: state.currentPage + 1,
        error: null,
      };

    case actionTypes.NO04_LOAD_MORE_FAILURE:
      return { ...state, loadingMore: false, error: action.payload };

    case actionTypes.NO04_CLEAR_RESULTS:
      return { ...state, orders: [], error: null, hasMore: true, currentPage: 0 };

    case actionTypes.NO04_CLEAR_COMPONENT_STORE:
      return { ...initialState };

    case actionTypes.NO04_ORDER_DETAIL_REQUEST:
      return { ...state, orderDetailLoading: true, orderDetail: null };

    case actionTypes.NO04_ORDER_DETAIL_SUCCESS:
      return { ...state, orderDetailLoading: false, orderDetail: action.payload };

    case actionTypes.NO04_ORDER_DETAIL_FAILURE:
      return { ...state, orderDetailLoading: false };

    case actionTypes.NO04_ORDER_DETAIL_CLEAR:
      return { ...state, orderDetail: null, orderDetailLoading: false };

    default:
      return state;
  }
};

export { NO04Reducer as default };
